module.exports = __webpack_public_path__ + "img/letter_door_bg.1ce203a4.png";